<template>
  <v-card flat class="footercard">
    <div class="footer-header">
      <div class="footer-header-image" v-if="image != null">
        <CImage :url="image" :alt="title" width="187px" height="70px" />
      </div>
      <span v-else-if="title != null" class="semibold footercard-title">{{
        title
      }}</span>
    </div>
    <div v-if="text != null">
      <CText :text="text" />
    </div>
    <div v-if="links != null">
      <v-list class="list" dense>
        <v-list-item v-for="(item, i) in links" :key="i" dense>
          <CText
            v-if="item.title != null"
            @click="redirect(item.url)"
            :text="item.title"
            :color_text="'dark_grey'"
            :justify="false"
          />
        </v-list-item>
      </v-list>
    </div>
  </v-card>
</template>

<script>
import CImage from "@/components/HomeSections/SubComponents/Image";
import CText from "@/components/HomeSections/SubComponents/Text";

export default {
  name: "FooterCard",
  components: { CImage, CText },
  props: {
    title: {
      type: String,
      default: null
    },
    links: {
      type: Array,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    image: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped>
.list {
  padding: 0px !important;
}

.footercard-title {
  margin-left: 1.2em;
}

.footercard {
  padding: 0px 30px 0px 30px;
  max-width: 450px;
}

.footer-header {
  min-height: 70px;
  display: flex;
  align-items: center;
}
</style>
